import React from "react";
import dayjs from "dayjs";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/DeleteForeverTwoTone";
import AddIcon from "@mui/icons-material/Add";
import { baseFontStyle, menuItemTextStyle } from "../../tickets/tickets";

const EffortDetails = (props) => {
  const {
    effortDialog,
    effortLoading,
    totalHours,
    overallEndDate,
    overallStartDate,
    handleCloseEffortDialog,
    handleEffortChange,
    handleDeleteRow,
    handleEffortSubmit,
    handleAddEffortRow,
  } = props;
  return (
    <Dialog
      open={effortDialog.open}
      onClose={handleCloseEffortDialog}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle
        sx={{
          ...baseFontStyle,
          fontSize: "1rem",
          fontWeight: 600,
        }}
      >
        Add Effort Details
      </DialogTitle>

      <DialogContent>
        <Box sx={{ mt: 2 }}>
          {effortDialog.rows.map((row, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                mb: 2,
              }}
            >
              <TextField
                fullWidth
                label="Type"
                disabled={effortLoading}
                InputLabelProps={{
                  sx: menuItemTextStyle,
                }}
                sx={{
                  "& .MuiInputBase-input": menuItemTextStyle,
                }}
                value={row.type}
                onChange={(e) =>
                  handleEffortChange(index, "type", e.target.value)
                }
              />

              <TextField
                fullWidth
                label="Effort (hrs)"
                type="number"
                disabled={effortLoading}
                InputLabelProps={{
                  sx: menuItemTextStyle,
                }}
                sx={{
                  "& .MuiInputBase-input": menuItemTextStyle,
                }}
                value={row.effort}
                onChange={(e) =>
                  handleEffortChange(index, "effort", e.target.value)
                }
              />
              <TextField
                label="Start Date"
                type="date"
                fullWidth
                disabled={effortLoading}
                InputLabelProps={{
                  shrink: true,
                  sx: menuItemTextStyle,
                }}
                sx={{
                  "& .MuiInputBase-input": menuItemTextStyle,
                }}
                inputProps={{
                  min: dayjs().format("YYYY-MM-DD"),
                }}
                value={
                  row.startDate ? dayjs(row.startDate).format("YYYY-MM-DD") : ""
                }
                onChange={(e) =>
                  handleEffortChange(index, "startDate", e.target.value)
                }
              />
              <TextField
                label="End Date"
                type="date"
                fullWidth
                disabled={effortLoading}
                InputLabelProps={{
                  shrink: true,
                  sx: menuItemTextStyle,
                }}
                sx={{
                  "& .MuiInputBase-input": menuItemTextStyle,
                }}
                inputProps={{
                  min: dayjs(row.startDate).format("YYYY-MM-DD"),
                }}
                value={
                  row.endDate ? dayjs(row.endDate).format("YYYY-MM-DD") : ""
                }
                onChange={(e) =>
                  handleEffortChange(index, "endDate", e.target.value)
                }
              />

              <IconButton
                color="error"
                onClick={() => handleDeleteRow(index)}
                disabled={effortLoading || effortDialog.rows.length === 1}
              >
                <DeleteIcon />
              </IconButton>
            </Box>
          ))}

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mt: 2,
            }}
          >
            <Button
              disabled={effortLoading}
              variant="outlined"
              sx={{
                ...menuItemTextStyle,
                textTransform: "none",
              }}
              startIcon={<AddIcon />}
              onClick={handleAddEffortRow}
            >
              Add Row
            </Button>

            <Typography
              sx={{
                ...menuItemTextStyle,
                fontWeight: 600,
              }}
              variant="subtitle1"
              fontWeight={600}
            >
              Total Hours: {totalHours}
            </Typography>
          </Box>
          <Box
            sx={{
              mt: 2,
              p: 2,
              border: "1px solid #e0e0e0",
              borderRadius: 1,
              backgroundColor: "#fafafa",
            }}
          >
            <Typography
              sx={{
                ...menuItemTextStyle,
                fontWeight: 600,
                mb: 1,
              }}
            >
              Overall Timeline
            </Typography>

            <Typography sx={menuItemTextStyle}>
              Start Date: {overallStartDate || "-"}
            </Typography>

            <Typography sx={menuItemTextStyle}>
              End Date: {overallEndDate || "-"}
            </Typography>
          </Box>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button
          disabled={effortLoading}
          sx={{
            ...menuItemTextStyle,
            textTransform: "none",
          }}
          onClick={handleCloseEffortDialog}
        >
          Cancel
        </Button>

        <Button
          disabled={effortLoading}
          loading={effortLoading}
          sx={{
            ...menuItemTextStyle,
            textTransform: "none",
          }}
          variant="contained"
          onClick={handleEffortSubmit}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EffortDetails;
